import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import usePayrollApi from "../../../services/payroll/payrollApi";
import moment from "moment";
import { Button } from "react-bootstrap";
import AddDeduction from "./addDeduction";
import { useQuery } from "@tanstack/react-query";
import BasicTable from "../../../components/UiComponent/customTable";
import CustomModal from "../../../components/UiComponent/Modal";
const Deduction = () => {
  const { t } = useTranslation();
  const { get_deduction_list } = usePayrollApi();
  const [showModal, setShowModal] = useState(false);
  const [DeductionId, setDeductionId] = useState();
  const [modal_title, setModalTitle] = useState();
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleButtonSubmit = () => {
    handleCloseModal();
  };
  const DeductionQuery = useQuery(["deduction_list"], () =>
    get_deduction_list()
  );
  const DeductionData = useMemo(() => {
    return DeductionQuery.data?.data?.deduction || [];
  }, [DeductionQuery.data]);
  if (DeductionQuery.isLoading) {
    return <div>Loading...</div>;
  }
  if (DeductionQuery.isError) {
    return <div>Error: {DeductionQuery.error.message}</div>;
  }
  const openUpdateDeductionModal = (event, id) => {
    event.preventDefault();
    handleShowModal();
    setDeductionId(id);
    setModalTitle("update_deduction_title");
  };
  const DeductionColumns = [
    {
      header: "full_name",
      accessorKey: "employee.first_name",
      cell: (row) => (
        <div>
          <p className="m-0 text-secondary small">
            {row.row.original.employee.first_name}{" "}
            {row.row.original.employee.father_name}
          </p>
          <p className="m-0 text-secondary small">
            {row.row.original.employee.phone}{" "}
          </p>
        </div>
      ),
    },
    {
      header: "department",
      accessorKey: "employee.department",
    },
    {
      header: "deduction",
      accessorKey: "deduction_name",
    },
    {
      header: "amount",
      accessorKey: "amount",
      cell: (row) => (
        <div>
          <p>
            {row.row.original.amount}
            <i className="m-0 text-secondary small">
              {row.row.original.is_percentage ? " % " : " "}
            </i>
          </p>
        </div>
      ),
    },

    {
      header: "from_date",
      accessor: "from_date",
      accessorFn: (row) => `${moment(row.from_date).format("YYYY-MM-DD")} `,
    },
    {
      header: "to_date",
      accessor: "to_date",
      accessorFn: (row) => `${moment(row.to_date).format("YYYY-MM-DD")}`,
    },

    {
      header: "action",
      accessor: "id",
      cell: (row) => (
        <Button
          variant="btn btn-info btn-sm"
          onClick={(e) => openUpdateDeductionModal(e, row.row.original)}
        >
          {t("update_deduction")}
        </Button>
      ),
    },
  ];

  const openAddDeductionModal = (event) => {
    event.preventDefault();
    handleShowModal();
    setDeductionId();
    setModalTitle("add_new_deduction");
  };
  return (
    <div>
      <BasicTable
        data={DeductionData}
        columns={DeductionColumns}
        title={`deduction_list`}
        actionButton={
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => openAddDeductionModal(e)}
          >
            {t("add_deduction")}
          </Button>
        }
      />

      <CustomModal
        show={showModal}
        title={modal_title}
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <AddDeduction
            closeModal={handleButtonSubmit}
            initialValues={DeductionId}
          />
        }
      />
    </div>
  );
};
export default Deduction;
